import * as Yup from 'yup'

export const creditCardFormValidation = Yup.object().shape({
  cardNameEmpty: Yup.bool()
    .oneOf([false], 'Card Holder Name')
    .required('Card Holder Name'),
  cardNumberEmpty: Yup.bool()
    .oneOf([false], 'Credit Card')
    .required('Credit Card'),
  cardExpiryEmpty: Yup.bool()
    .oneOf([false], 'Exp Date')
    .required('Exp Date'),
  cardCvvEmpty: Yup.bool()
    .oneOf([false], 'CVC')
    .required('CVC'),
})